import { useQuery } from '@tanstack/react-query';
import {
  brokerageFirmControllerGetBrokerageFirmQueryOptions,
  legacyPermissionsControllerAtMeQueryOptions,
} from 'korint-sdk';

export function useCurrentFirmType() {
  const { data: user, isLoading: isUserLoading } = useQuery({
    ...legacyPermissionsControllerAtMeQueryOptions(),
  });
  const { data: firmType, isLoading: isFirmTypeLoading } = useQuery({
    ...brokerageFirmControllerGetBrokerageFirmQueryOptions(user?.brokerageFirmId!),
    select: data => data.firmType,
    enabled: Boolean(user?.brokerageFirmId),
  });
  return { firmType, isLoading: isUserLoading || isFirmTypeLoading };
}
